/* eslint-disable react/require-default-props */
import * as React from 'react';
import PropTypes from 'prop-types';
import { SweepstakesWrapper } from './container/SweepstakesWrapper';
import { SweepstakesEntryCard } from './components/EntryCard/SweepstakesEntryCard';
import { SweepstakesDrawerContainer } from './container/SweepstakesDrawerContainer';

/*

Prompt:
  - Create a SweepstakesFullComponent component that behaves similar to this SweepstakesDrawersExample,
    except you pass in the mock as a prop.
  - Everything else about how it's used should be a 1-liner
  - Place the component within src/components/Sweepstakes and export it thru loyalty-benefits.js
    so it can be used outside of this repo as a 1-liner
  - The only things that are needed from SweepstakesDrawersExample are:
    - ComponentProviders
    - SweepstakesEntryCard
    - SweepstakesDrawerContainer
    ..Not the typography stuff
  - Keep this comment within the file

*/

/*
  SweepstakesFullComponent
  - Accepts a `sweepstakesData` prop (mock or real) and renders
    the entry card + drawer container using the new SweepstakesWrapper.
  - Intentionally minimal so it can be used as a 1-liner export.
*/
export function SweepstakesFullComponent({
  sweepstakesData,
  useRestAPI = false,
  showHeaders = false,
  cacheKey = 'sweepstakes-full-component-cache'
}) {
  const headerProps = showHeaders ? {
    showOutsideHeaderOn: ['MW', 'TW'],
    showInsideHeaderOn: ['DT']
  } : undefined;
  return (
    <SweepstakesWrapper
      cacheKey={cacheKey}
      sweepstakesData={sweepstakesData}
      useRestAPI={useRestAPI}
    >
      <SweepstakesEntryCard
        SweepstakesEntryCardHeaderProps={headerProps}
      />
      <SweepstakesDrawerContainer />
    </SweepstakesWrapper>
  );
}

SweepstakesFullComponent.propTypes = {
  sweepstakesData: PropTypes.shape({}),
  useRestAPI: PropTypes.bool,
  cacheKey: PropTypes.string,
  showHeaders: PropTypes.bool,
};

export default SweepstakesFullComponent;
